var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-alert',{staticStyle:{"width":"100%"},attrs:{"color":"info","colored-border":true,"border":"left"}},[_c('p',[_vm._v(_vm._s(_vm.message))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }